import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tabs } from 'antd';
import { Default } from '../../layouts';

import PageTitle from '../../components/PageTitle';
import PosesStatuses from './PosesStatuses';

const PosesDashboard = () => {
  const { t } = useTranslation();

  return (
    <Default>
      <PageTitle title={t('pages.posdashboard._')} />
      <Tabs>
        <Tabs.TabPane
          tab={t('pages.posdashboard.tabs.poses')}
          key="validators"
          active
        >
          <PosesStatuses />
        </Tabs.TabPane>
      </Tabs>
    </Default>
  );
};

export default PosesDashboard;
